export const iconFontAwesomeLogisticsBridgeLock = (
	<i className="fa-solid fa-bridge-lock"></i>
);
